import UserDetailModal from "../../components/Modals/UserDetailModal";
import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Input,
  Select,
  Modal,
  Table,
  DatePicker,
  Form,
  message,
  Spin,
  Pagination,
} from "antd";
import { Upload } from "antd";
import { UploadOutlined, SearchOutlined } from "@ant-design/icons";
import {
  CloseOutlined,
  EditOutlined,
  AppstoreOutlined,
  UnorderedListOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import style from "./SchoolUserList.module.css";
import { $userListEdu, getUserListEduFx } from "../../models/userListModel";
import { useUnit } from "effector-react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Checkbox } from "antd";

dayjs.extend(customParseFormat);

const { Search } = Input;
const { Option } = Select;

function EmployeeList({ userGroups = [] }) {
  console.log("✅ userGroups edu staff:", userGroups); // Add this here

  const employeeList = useUnit($userListEdu); // Data source
  const loading = useUnit(getUserListEduFx.pending);

  const [searchText, setSearchText] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [selectedDepartments, setSelectedDepartments] = useState([]); // Selected departments
  const [layout, setLayout] = useState("cards"); // State for layout toggle

  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [form] = Form.useForm(); // Form instance
  const [showCuratorsOnly, setShowCuratorsOnly] = useState(false);
  const [uploadedPhotoBase64, setUploadedPhotoBase64] = useState(null);
  const stableUserGroups = useMemo(
    () => JSON.stringify(userGroups),
    [userGroups]
  );
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10; // Number of employees per page

  const [pagination, setPagination] = useState({
    current: 1, // Current page number
    pageSize: 10, // Rows per page
  });

  const isPifagor = userGroups.includes("Pifagor"); // ✅ Check if the user belongs to Pifagor

  const curatorLabel = isPifagor ? "Трэкеров" : "Кураторов"; // ✅ Use the correct term based on the school
  const curatorPosition = isPifagor ? "Трэкер" : "Куратор"; // ✅ Match the correct position name

  const handleTableChange = (pagination) => {
    setPagination({
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };
  const [loadedEmployees, setLoadedEmployees] = useState([]); // Add this state

  const [isSaving, setIsSaving] = useState(false);

  const handlePhotoUpload = ({ fileList }) => {
    if (fileList.length > 0) {
      const file = fileList[0].originFileObj || fileList[0];

      // Convert photo to Base64
      const reader = new FileReader();
      reader.onload = (e) => {
        setUploadedPhotoBase64(e.target.result);
        message.success("Photo uploaded successfully!");
      };
      reader.readAsDataURL(file);
    } else {
      setUploadedPhotoBase64(null); // Clear photo if removed
      message.info("Photo removed.");
    }
  };

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const [day, month, year] = dateString.split(".");
    return new Date(`${year}-${month}-${day}`);
  };

  const [isAddEmployeeModalVisible, setIsAddEmployeeModalVisible] =
    useState(false);

  const handleAddNewEmployee = () => {
    form.resetFields(); // Clear the form fields
    setIsAddEmployeeModalVisible(true); // Show the modal
  };

  const handleSaveNewEmployee = async (values) => {
    if (!uploadedPhotoBase64) {
      message.error(
        "Пожалуйста загрузите фото сотрудника перед его добавлением."
      );
      return;
    }

    // Check for duplicate employee
    const isDuplicate = loadedEmployees.some(
      (emp) =>
        emp.user_name === values.user_name &&
        emp.user_surname === values.user_surname &&
        emp.date_of_birth === dayjs(values.date_of_birth).format("DD.MM.YYYY")
    );

    if (isDuplicate) {
      message.error(
        "Вы не можете добавить уже существующего сотрудника. Пожалуйста, обновите страницу, если вы не видите сотрудника в списке."
      );
      return;
    }

    setIsSaving(true);

    try {
      // Process position field
      const empPositionArray = Array.isArray(values.emp_position)
        ? values.emp_position
        : typeof values.emp_position === "string"
        ? values.emp_position.split(",").map((pos) => pos.trim())
        : [];

      // Format date
      const formattedDateOfBirth = values.date_of_birth
        ? dayjs(values.date_of_birth).format("DD.MM.YYYY")
        : null;

      // Location mapping
      const locationPlaceIds = {
        "Middle School": "pmsa10h3p6",
        "High School": "phsa10m6f1",
        "Back Office": "pfga10y8m6",
      };

      const place_id_by_location = isPifagor
        ? locationPlaceIds[values.emp_location] || "phsa10m6f1"
        : "zasa05e1p1";

      // Prepare request body
      const requestBody = {
        place_id: place_id_by_location,
        properties: {
          user_name: values.user_name,
          user_surname: values.user_surname,
          date_of_birth: formattedDateOfBirth,
          emp_category: "Сотрудник",
          emp_location: isPifagor ? values.emp_location : undefined,
          emp_department: Array.isArray(values.emp_department)
            ? values.emp_department
            : [values.emp_department],
          emp_position: empPositionArray,
          user_email: values.user_email || "-",
          user_mobile: values.user_mobile,
          user_address: values.user_address,
          emp_type: values.emp_type,
        },
        data_url: [uploadedPhotoBase64],
      };

      // Prepare new employee object for local state
      const newEmployee = {
        ...values,
        date_of_birth: formattedDateOfBirth,
        emp_category: "Сотрудник",
        emp_department: Array.isArray(values.emp_department)
          ? values.emp_department
          : [values.emp_department],
        emp_position: empPositionArray,
        user_email: values.user_email || "-",
        sort_key: place_id_by_location,
        presigned_url: uploadedPhotoBase64,
      };

      // API call
      const response = await fetch(
        "https://ste1h7g7s7.execute-api.eu-west-1.amazonaws.com/LoyaltySystem1/UserRecords",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();
      if (response.ok) {
        message.success("Новый сотрудник успешно добавлен!");
        setLoadedEmployees((prevEmployees) => [...prevEmployees, newEmployee]);
      } else {
        message.error(`Ошибка добавления: ${data.body}`);
      }
    } catch (error) {
      console.error("Error adding employee:", error);
      message.error(`Ошибка подключения: ${error.message}`);
    } finally {
      setIsSaving(false);
      setIsAddEmployeeModalVisible(false);
      setUploadedPhotoBase64(null);
    }
  };

  const handleEdit = (employee) => {
    console.log("🔍 Editing Employee Object:", employee); // Check if partition_key exists

    if (!employee.partition_key || !employee.sort_key) {
      console.error(
        "⚠️ partition_key or sort_key is missing in the employee object:",
        employee
      );
      message.error("Ошибка: отсутствуют ключи partition_key или sort_key.");
      return;
    }

    const empPositionString = employee.emp_position
      ? employee.emp_position.join(", ")
      : "";

    form.setFieldsValue({
      ...employee,
      emp_position: empPositionString, // Convert array to string
      date_of_birth: employee.date_of_birth
        ? dayjs(employee.date_of_birth, "DD.MM.YYYY")
        : null,
    });

    setEditingRecord(employee);
    setIsEditModalVisible(true);
  };

  const [editLoading, setEditLoading] = useState(false);

  const handleSaveEdit = async (values) => {
    console.log("🏁 Form submitted with values:", values);
    setIsSaving(true);

    // Format date if provided
    const formattedDateOfBirth = values.date_of_birth
      ? dayjs(values.date_of_birth).format("DD.MM.YYYY")
      : undefined;

    // Convert position string to array if needed
    const empPositionArray = values.emp_position
      ? Array.isArray(values.emp_position)
        ? values.emp_position
        : values.emp_position.split(",").map((pos) => pos.trim())
      : [];

    // Prepare the updated employee data - DON'T spread editingRecord here
    const updatedData = {
      user_name: values.user_name,
      user_surname: values.user_surname,
      date_of_birth: formattedDateOfBirth,
      user_email: values.user_email || "",
      user_address: values.user_address,
      user_mobile: values.user_mobile,
      emp_department: Array.isArray(values.emp_department)
        ? values.emp_department
        : [values.emp_department],
      emp_position: empPositionArray,
      emp_type: values.emp_type,
      emp_location: isPifagor
        ? values.emp_location
        : editingRecord.emp_location,
    };

    // Remove any undefined values
    Object.keys(updatedData).forEach((key) => {
      if (updatedData[key] === undefined) {
        delete updatedData[key];
      }
    });

    // Prepare the API request body
    const requestBody = {
      type: "employee",
      partition_key: editingRecord.partition_key,
      sort_key: editingRecord.sort_key,
      data: {
        ...editingRecord, // Start with original record
        ...updatedData, // Then apply updates
      },
    };

    console.log("API Request Payload:", JSON.stringify(requestBody, null, 2));

    try {
      const response = await fetch(
        "https://i8wkv4zm9k.execute-api.eu-west-1.amazonaws.com/ChangeInfoOnEmployees/ChangeEDUInfo2",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();
      console.log("API Response:", responseData);

      if (response.ok) {
        message.success("Данные сотрудника успешно обновлены!");

        // Update local state
        setLoadedEmployees((prevEmployees) =>
          prevEmployees.map((employee) =>
            employee.partition_key === editingRecord.partition_key &&
            employee.sort_key === editingRecord.sort_key
              ? { ...employee, ...updatedData }
              : employee
          )
        );

        setIsEditModalVisible(false);
      } else {
        throw new Error(responseData.message || "Failed to update employee");
      }
    } catch (error) {
      console.error("Edit failed:", error);
      message.error(`Ошибка при сохранении: ${error.message}`);
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    if (userGroups?.length > 0) {
      console.log("🔄 Fetching employees for:", userGroups);
      getUserListEduFx({ userGroups, emp_category: "Сотрудник" }).then(
        (data) => {
          console.log("✅ Employee list loaded:", data);
          setLoadedEmployees(data);
        }
      );
    }
  }, [stableUserGroups]);

  // Get unique departments for dropdown options
  const uniqueDepartments = useMemo(() => {
    const departments = employeeList.flatMap(
      (employee) => employee.emp_department || []
    );
    return [...new Set(departments)];
  }, [employeeList]);

  const locationOptions = ["Middle School", "High School", "Back Office"]; // ✅ Static options for Pifagor

  const departmentOptions = isPifagor
    ? [
        "Административный отдел",
        "Учебный отдел",
        "Воспитательный отдел",
        "Отдел Продаж",
      ] // ✅ Static options for Pifagor
    : uniqueDepartments; // ✅ Default options for Aubakirova

  const departmentFilterOptions = isPifagor
    ? [
        "Административный отдел",
        "Учебный отдел",
        "Воспитательный отдел",
        "Отдел Продаж",
      ] // ✅ Fixed options for Pifagor
    : uniqueDepartments; // ✅ Dynamic options for Aubakirova

  // Get unique departments for dropdown options
  const uniqueEmpType = useMemo(() => {
    const empTypes = employeeList.flatMap(
      (employee) => employee.emp_type || []
    );
    return [...new Set(empTypes)];
  }, [employeeList]);

  const positionOptions = isPifagor
    ? [
        "Преподаватель русского языка и литературы",
        "Преподаватель географии",
        "Преподаватель казахского языка и литературы",
        "Академический директор",
        "Преподаватель истории",
        "Преподаватель математики",
        "Преподаватель английского языка",
        "Преподаватель физической культуры",
        "Преподаватель физики",
        "Преподаватель информатики",
        "Преподаватель химии",
        "Преподаватель биологии",
        "Трекер",
        "Психолог",
        "МОП",
        "РОП",
        "Куратор",
        "Техничка",
        "Охранник",
        "Маркетолог",
        "Видеограф",
        "SMM-менеджер",
        "Мобилограф",
        "Фотограф",
        "Медсестра",
        "Заведующий хозяйством",
        "Садовник",
        "Аналитик",
      ]
    : [];

  const statusOptions = isPifagor ? ["Работает", "Уволен"] : uniqueEmpType;

  // some interesting changes are from here
  const normalizeText = (text) =>
    text
      .normalize("NFKC") // Normalize Unicode inconsistencies
      .replace(/\p{Diacritic}/gu, "") // Remove diacritic marks (hidden differences)
      .toLowerCase()
      .replace(/й/g, "и"); // Ensure й & и match

  const filteredEmployees = useMemo(() => {
    return loadedEmployees
      .filter((employee) => {
        if (!employee || employee.emp_category !== "Сотрудник") return false;

        const employeeValues = Object.values(employee)
          .map((value) => normalizeText(String(value))) // Convert & normalize all text
          .join(" ");

        const normalizedSearchText = normalizeText(searchText);

        const matchesSearch = employeeValues.includes(normalizedSearchText);

        const matchesDepartment =
          selectedDepartments.length === 0 ||
          (Array.isArray(employee.emp_department) &&
            employee.emp_department.some((dept) =>
              selectedDepartments.includes(dept)
            ));

        const matchesCuratorFilter =
          !showCuratorsOnly ||
          (Array.isArray(employee.emp_position) &&
            employee.emp_position.includes(curatorPosition));

        return matchesSearch && matchesDepartment && matchesCuratorFilter;
      })
      .sort((a, b) => {
        if (sortOption === "name-asc") {
          return a.user_name.localeCompare(b.user_name, "ru");
        } else if (sortOption === "name-desc") {
          return b.user_name.localeCompare(a.user_name, "ru");
        }
        return 0;
      });
  }, [
    loadedEmployees,
    searchText,
    sortOption,
    selectedDepartments,
    showCuratorsOnly,
  ]);

  const paginatedEmployees = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return filteredEmployees.slice(startIndex, startIndex + pageSize);
  }, [filteredEmployees, currentPage]);

  // Add this function to create dynamic rules
  const getFieldRules = (fieldName) => {
    const baseRules = [];

    // Common required fields for both schools
    const requiredFields = [
      "user_name",
      "user_surname",
      "emp_department",
      "emp_position",
      "emp_type",
      "date_of_birth",
    ];

    // Pifagor-specific required fields
    if (isPifagor) {
      requiredFields.push("emp_location");
    } else {
      // Aubakirova-specific requirements
      requiredFields.push("user_address", "user_mobile");
    }

    if (requiredFields.includes(fieldName)) {
      baseRules.push({
        required: true,
        message: `Пожалуйста заполните ${fieldName}`,
      });
    }

    // Special cases
    if (fieldName === "date_of_birth") {
      baseRules.push({
        validator: (_, value) => {
          if (!value) return Promise.reject("Пожалуйста введите дату рождения");
          if (!dayjs(value, "DD.MM.YYYY", true).isValid()) {
            return Promise.reject("Некорректный формат даты (ДД.ММ.ГГГГ)");
          }
          return Promise.resolve();
        },
      });
    }

    return baseRules;
  };

  const handleDelete = (student) => {
    Modal.confirm({
      title: "Подтверждение",
      content: `Вы уверены, что хотите отметить сотрудника ${student.user_surname} ${student.user_name} как "Уволен"?`,
      okText: "Да",
      cancelText: "Отмена",
      onOk: async () => {
        try {
          setIsSaving(true);
          const requestBody = {
            type: "student",
            partition_key: student.partition_key,
            sort_key: student.sort_key,
            data: {
              ...student,
              emp_category: "Уволен",
            },
          };

          const response = await fetch(
            "https://i8wkv4zm9k.execute-api.eu-west-1.amazonaws.com/ChangeInfoOnEmployees/ChangeEDUInfo2",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(requestBody),
            }
          );

          if (response.ok) {
            message.success('Сотрудник успешно отмечен как "Уволен"');
            console.log(loadedEmployees);

            setLoadedEmployees((prev) =>
              prev.filter((s) => s.partition_key !== student.partition_key)
            );
          } else {
            throw new Error("Ошибка сервера");
          }
        } catch (error) {
          message.error(`Ошибка: ${error.message}`);
        } finally {
          setIsSaving(false);
        }
      },
    });
  };

  // ✳ Add these useState hooks inside your component:
  const [selectedUser, setSelectedUser] = useState(null);
  const [isUserModalVisible, setIsUserModalVisible] = useState(false);

  const openUserModal = (student) => {
    setSelectedUser(student);
    setIsUserModalVisible(true);
  };

  const closeUserModal = () => {
    setIsUserModalVisible(false);
    setSelectedUser(null);
  };

  return (
    <div className={style.userList_wrapper}>
      <div>
        <h1 className={style.userList_title}>Список сотрудников</h1>
        <h2 className={style.userList_title}>
          Всего: {loading ? <Spin size="small" /> : filteredEmployees.length}
        </h2>
      </div>

      {/* Top Controls */}
      <div className={style.user_list_top_wrapper}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px", // Spacing between elements
            flexWrap: "wrap", // Ensure it wraps on smaller screens
            marginBottom: "16px", // Add spacing below the filter section
          }}
        >
          {/* Search Bar */}
          {/* <Search
            placeholder="Поиск по любому параметру"
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: "250px" }} // Consistent width
            enterButton={false} // Removes the default search button
          /> */}
          <Input
            placeholder="Поиск по любому параметру"
            onChange={(e) => setSearchText(e.target.value)}
            style={{
              width: "250px",
              height: "32px", // Match Select component height
              borderRadius: "0px", // 🔥 Makes corners sharp
              border: "1px solid #d9d9d9", // Standard antd border
              fontSize: "14px",
            }}
            suffix={
              <SearchOutlined style={{ fontSize: "16px", color: "#888" }} />
            }
          />

          {/* Sort Dropdown */}
          <Select
            placeholder="Сортировка"
            onChange={setSortOption}
            style={{ width: "200px" }} // Consistent width
          >
            <Option value="name-asc">Имя: А-Я</Option>
            <Option value="name-desc">Имя: Я-А</Option>
          </Select>
          {/* Department Filter */}
          <Select
            mode="multiple"
            placeholder="Фильтр по отделу"
            value={selectedDepartments}
            onChange={setSelectedDepartments}
            style={{ width: "250px" }}
            allowClear
          >
            {departmentFilterOptions.map((dept) => (
              <Select.Option key={dept} value={dept}>
                {dept}
              </Select.Option>
            ))}
          </Select>
          {/* Checkbox for Curator Filter */}
          {!isPifagor && (
            <Checkbox
              checked={showCuratorsOnly}
              onChange={(e) => setShowCuratorsOnly(e.target.checked)}
            >
              Показывать только {curatorLabel}
            </Checkbox>
          )}

          {/* Add Employee Button */}
          <Button
            type="primary"
            icon={<UserAddOutlined />}
            onClick={handleAddNewEmployee}
          >
            Добавить сотрудника
          </Button>
          {/* Layout Toggle Buttons */}
          <div>
            <Button
              onClick={() => setLayout("cards")}
              icon={<AppstoreOutlined />}
              type={layout === "cards" ? "primary" : "default"}
              style={{ marginRight: "8px" }}
            />
            <Button
              onClick={() => setLayout("list")}
              icon={<UnorderedListOutlined />}
              type={layout === "list" ? "primary" : "default"}
            />
          </div>
        </div>
      </div>

      {/* Employees View */}
      {layout === "cards" ? (
        <div
          className={style.cards_wrapper}
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            justifyContent: "center",
          }}
        >
          {paginatedEmployees.map((employee) => (
            <div
              key={employee.id}
              style={{
                position: "relative",
                border: "1px solid #ddd",
                borderRadius: "10px",
                width: "45%",
                minWidth: "350px",
                display: "flex",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
                backgroundColor: "#fff",
              }}
            >
              {/* Edit Button */}
              <div
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                }}
              >
                <Button
                  icon={<EditOutlined />}
                  onClick={() => handleEdit(employee)}
                  style={{
                    backgroundColor: "#007bff",
                    color: "white",
                  }}
                />
                <Button
                  icon={<CloseOutlined />}
                  onClick={() => handleDelete(employee)}
                  style={{
                    backgroundColor: "#ff4d4f",
                    color: "white",
                  }}
                />
              </div>

              {/* Photo Section */}
              <div style={{ padding: "15px" }}>
                <img
                  src={employee.presigned_url || "/default_employee_image.png"}
                  alt="Employee"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #007bff",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    Modal.info({
                      title: "Просмотр изображения",
                      content: (
                        <img
                          src={
                            employee.presigned_url ||
                            "/default_employee_image.png"
                          }
                          alt="Enlarged Student"
                          style={{ width: "100%" }}
                        />
                      ),
                      icon: null,
                    });
                  }}
                  loading="lazy"
                />
              </div>

              {/* Details Section */}
              <div style={{ flex: "1", padding: "15px" }}>
                <h3
                  style={{
                    margin: "0 0 10px",
                    fontSize: "18px",
                  }}
                  onClick={() => openUserModal(employee)}
                >
                  {`${employee.user_name} ${employee.user_surname}`}
                </h3>
                {isPifagor && (
                  <div>
                    <b>Локация:</b> {employee.emp_location}
                  </div>
                )}

                <div>
                  <b>Отдел:</b> {employee.emp_department}
                </div>
                <div>
                  <b>Должность:</b> {employee.emp_position.join(", ")}
                </div>
                <div>
                  <b>Статус:</b> {employee.emp_type}
                </div>

                {employee.emp_position.includes("Куратор") && (
                  <div>
                    <b>Класс:</b> {employee.grade_number}
                    {employee.grade_letter}
                  </div>
                )}
                <div>
                  <b>Дата рождения:</b> {employee.date_of_birth}
                </div>
                <div>
                  <b>Номер телефона:</b> {employee.user_mobile}
                </div>
                <div>
                  <b>Адрес:</b> {employee.user_address}
                </div>
                <div>
                  <b>Email:</b> {employee.user_email}
                </div>
              </div>
            </div>
          ))}
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={filteredEmployees.length} // ✅ Uses total filtered employees
              showSizeChanger={false} // Set to true if you want users to change page size
              onChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : (
        <Table
          dataSource={filteredEmployees}
          rowKey="id"
          loading={loading}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50"],
          }}
          onChange={handleTableChange}
          columns={[
            {
              title: "№",
              key: "index",
              render: (text, record, index) =>
                (pagination.current - 1) * pagination.pageSize + index + 1,
              width: 50,
            },
            {
              title: "Имя",
              dataIndex: "user_name",
              key: "user_name",
            },
            {
              title: "Фамилия",
              dataIndex: "user_surname",
              key: "user_surname",
            },
            {
              title: "Локация",
              dataIndex: "emp_location",
              key: "emp_location",
              hidden: !isPifagor,
            },
            {
              title: "Отдел",
              dataIndex: "emp_department",
              key: "emp_department",
            },
            {
              title: "Должность",
              key: "emp_position",
              render: (text, record) =>
                Array.isArray(record.emp_position)
                  ? record.emp_position.join(", ") // ✅ Convert array to string
                  : record.emp_position || "-",
            },

            {
              title: "Статус",
              dataIndex: "emp_type",
              key: "emp_type",
            },
            {
              title: "Класс",
              key: "grade_info",
              render: (text, record) =>
                Array.isArray(record.emp_position) &&
                record.emp_position.some((pos) =>
                  ["Куратор", "Трэкер"].includes(pos)
                ) ? (
                  <span>
                    {record.grade_number}
                    {record.grade_letter}
                  </span>
                ) : (
                  "-"
                ),
            },

            {
              title: "Дата рождения",
              dataIndex: "date_of_birth",
              key: "date_of_birth",
            },
            {
              title: "Номер телефона",
              dataIndex: "user_mobile",
              key: "user_mobile",
            },
            {
              title: "Адрес",
              dataIndex: "user_address",
              key: "user_address",
            },
            {
              title: "Email",
              dataIndex: "user_email",
              key: "user_email",
            },
            {
              title: "Действия",
              key: "actions",
              render: (record) => (
                <Button
                  icon={<EditOutlined />}
                  onClick={() => handleEdit(record)}
                >
                  Редактировать
                </Button>
              ),
            },
          ]}
        />
      )}

      <Modal
        title="Редактирование Сотрудника"
        visible={isEditModalVisible}
        onCancel={() => {
          setIsEditModalVisible(false);
          form.resetFields();
        }}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveEdit}
          onFinishFailed={({ errorFields }) => {
            console.log("Validation failed:", errorFields);
            message.error("Пожалуйста, заполните все обязательные поля");
          }}
        >
          <Form.Item
            label="Имя"
            name="user_name"
            rules={getFieldRules("user_name")}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Фамилия"
            name="user_surname"
            rules={getFieldRules("user_surname")}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Локация"
            name="emp_location"
            rules={getFieldRules("emp_location")}
            hidden={!isPifagor}
          >
            <Select placeholder="Выберите локацию">
              {locationOptions.map((loc) => (
                <Select.Option key={loc} value={loc}>
                  {loc}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Отдел"
            name="emp_department"
            rules={[
              {
                required: true,
                message: "Пожалуйста выберите отдел",
              },
            ]}
          >
            <Select
              placeholder="Выберите отдел"
              onChange={(value) =>
                form.setFieldsValue({ emp_department: [value] })
              } // ✅ Always store as an array
            >
              {departmentOptions.map((dept) => (
                <Select.Option key={dept} value={dept}>
                  {dept}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Должность"
            name="emp_position"
            rules={[
              {
                required: true,
                message: "Выберите или введите должность",
              },
            ]}
          >
            {isPifagor ? (
              // ✅ Dropdown for Pifagor
              <Select placeholder="Выберите должность" mode="single">
                {positionOptions.map((pos) => (
                  <Select.Option key={pos} value={pos}>
                    {pos}
                  </Select.Option>
                ))}
              </Select>
            ) : (
              // ✅ Tag-based input for Aubakirova
              <Select
                mode="tags"
                placeholder="Введите должности через запятую"
                tokenSeparators={[","]}
              />
            )}
          </Form.Item>

          <Form.Item
            label="Статус"
            name="emp_type"
            rules={[{ required: true, message: "Выберите статус" }]}
          >
            <Select placeholder="Выберите статус">
              {isPifagor
                ? ["Работает", "Уволен"].map((status) => (
                    <Select.Option key={status} value={status}>
                      {status}
                    </Select.Option>
                  ))
                : [
                    "Почасовик",
                    "Оклад",
                    "Декрет",
                    "Полставки",
                    "Уволен",
                    "Неизвестно",
                  ].map((status) => (
                    <Select.Option key={status} value={status}>
                      {status}
                    </Select.Option>
                  ))}
            </Select>
          </Form.Item>

          {/* <Form.Item
            label="Дата рождения"
            name="date_of_birth"
            rules={[
              {
                required: true,
                message: "Пожалуйста, выберите или введите дату рождения",
              },
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.reject(
                      "Пожалуйста, выберите или введите дату."
                    );
                  }
                  if (!dayjs(value, "DD.MM.YYYY", true).isValid()) {
                    return Promise.reject(
                      "Некорректный формат даты (ДД.ММ.ГГГГ)."
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <DatePicker
              format="DD.MM.YYYY"
              style={{ width: "100%" }}
              placeholder="Введите или выберите дату"
              value={form.getFieldValue("date_of_birth")}
              onChange={(date) => form.setFieldsValue({ date_of_birth: date })}
              onBlur={(e) => {
                const enteredDate = e.target.value;
                if (dayjs(enteredDate, "DD.MM.YYYY", true).isValid()) {
                  form.setFieldsValue({
                    date_of_birth: dayjs(enteredDate, "DD.MM.YYYY"),
                  });
                } else if (enteredDate) {
                  message.error(
                    "Некорректный формат даты. Используйте ДД.ММ.ГГГГ"
                  );
                }
              }}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
          </Form.Item> */}

          <Form.Item
            label="Дата рождения"
            name="date_of_birth"
            rules={getFieldRules("date_of_birth")}
          >
            <DatePicker
              format="DD.MM.YYYY"
              style={{ width: "100%" }}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
          </Form.Item>
          <Form.Item
            label="Адрес"
            name="user_address"
            rules={getFieldRules("user_address")}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Номер телефона"
            name="user_mobile"
            rules={
              isPifagor
                ? []
                : [
                    {
                      required: true,
                      message: "Пожалуйста введите номер телефона",
                    },
                  ]
            } // ✅ Optional for Pifagor
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="user_email"
            rules={[
              {
                required: false,
                message: "Пожалуйста введите почтовый адрес",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => console.log("Save button clicked")}
              loading={isSaving}
            >
              {isSaving ? "Сохранение..." : "Сохранить"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Добавить нового сотрудника"
        visible={isAddEmployeeModalVisible}
        onCancel={() => setIsAddEmployeeModalVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveNewEmployee}
          onFinishFailed={(errorInfo) => {
            console.log("Form submission failed:", errorInfo);
            message.error(
              "Пожалуйста, заполните все обязательные поля правильно"
            );
          }}
        >
          <Form.Item label="Фото Сотрудника">
            <Upload
              name="photo"
              listType="picture"
              maxCount={1}
              beforeUpload={() => false} // Prevent auto-upload
              onChange={handlePhotoUpload}
              accept="image/*"
            >
              <Button icon={<UploadOutlined />}>
                Загрузить фото (.jpg/jpeg)
              </Button>
            </Upload>
            {uploadedPhotoBase64 && (
              <div style={{ marginTop: 10 }}>
                <img
                  src={uploadedPhotoBase64}
                  alt="Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                  }}
                />
              </div>
            )}
          </Form.Item>

          <Form.Item
            label="Имя"
            name="user_name"
            rules={[
              {
                required: true,
                message: "Пожалуйста введите имя",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Фамилия"
            name="user_surname"
            rules={[
              {
                required: true,
                message: "Пожалуйста введите фамилию",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Локация"
            name="emp_location"
            rules={[
              {
                required: isPifagor, // Only required for Pifagor
                message: "Пожалуйста введите локацию",
              },
            ]}
            hidden={!isPifagor} // Only show for Pifagor
          >
            <Select placeholder="Выберите локацию">
              {locationOptions.map((loc) => (
                <Select.Option key={loc} value={loc}>
                  {loc}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Отдел"
            name="emp_department"
            rules={[
              {
                required: true,
                message: "Пожалуйста выберите отдел",
              },
            ]}
          >
            <Select
              placeholder="Выберите отдел"
              onChange={(value) =>
                form.setFieldsValue({ emp_department: [value] })
              } // ✅ Always store as an array
            >
              {departmentOptions.map((dept) => (
                <Select.Option key={dept} value={dept}>
                  {dept}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Должность"
            name="emp_position"
            rules={[
              {
                required: true,
                message: "Выберите или введите должность",
                validator: (_, value) => {
                  if (!value || (Array.isArray(value) && value.length === 0)) {
                    return Promise.reject("Выберите или введите должность");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            {isPifagor ? (
              <Select
                placeholder="Выберите должность"
                options={positionOptions.map((pos) => ({
                  value: pos,
                  label: pos,
                }))}
              />
            ) : (
              <Select
                mode="tags"
                placeholder="Введите должности через запятую"
                tokenSeparators={[","]}
                options={[]} // Allows free-form input
              />
            )}
          </Form.Item>
          <Form.Item
            label="Статус"
            name="emp_type"
            rules={[{ required: true, message: "Выберите статус" }]}
          >
            <Select placeholder="Выберите статус">
              {isPifagor
                ? ["Работает", "Уволен"].map((status) => (
                    <Select.Option key={status} value={status}>
                      {status}
                    </Select.Option>
                  ))
                : [
                    "Почасовик",
                    "Оклад",
                    "Декрет",
                    "Полставки",
                    "Уволен",
                    "Неизвестно",
                  ].map((status) => (
                    <Select.Option key={status} value={status}>
                      {status}
                    </Select.Option>
                  ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Дата рождения"
            name="date_of_birth"
            rules={[
              {
                required: true,
                message: "Пожалуйста выберите дату рождения",
              },
            ]}
          >
            <DatePicker
              format="DD.MM.YYYY"
              style={{ width: "100%" }}
              placeholder="Выберите или введите дату"
              onChange={(date) => form.setFieldsValue({ date_of_birth: date })}
              onBlur={(e) => {
                const enteredDate = e.target.value;
                if (dayjs(enteredDate, "DD.MM.YYYY", true).isValid()) {
                  form.setFieldsValue({
                    date_of_birth: dayjs(enteredDate, "DD.MM.YYYY"),
                  });
                } else if (enteredDate) {
                  message.error(
                    "Некорректный формат даты. Используйте ДД.ММ.ГГГГ"
                  );
                }
              }}
            />
          </Form.Item>

          <Form.Item
            label="Адрес"
            name="user_address"
            rules={
              isPifagor
                ? []
                : [
                    {
                      required: true,
                      message: "Пожалуйста введите адрес",
                    },
                  ]
            } // ✅ Optional for Pifagor
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Номер телефона"
            name="user_mobile"
            rules={
              isPifagor
                ? []
                : [
                    {
                      required: true,
                      message: "Пожалуйста введите номер телефона",
                    },
                  ]
            } // ✅ Optional for Pifagor
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="user_email"
            rules={[
              {
                required: false,
                message: "Пожалуйста введите почтовый адрес",
              },
              {
                type: "email",
                message: "Пожалуйста введите валидный почтовый адрес",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={isSaving}>
              {isSaving ? "Сохранение..." : "Сохранить"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <UserDetailModal
        visible={isUserModalVisible}
        onClose={closeUserModal}
        user={selectedUser}
      />
    </div>
  );
}

export default EmployeeList;
